export default "__VITE_ASSET__DAOuiqEK__"